import { Paragraph10 } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

const ApiReferenceTypeText: FC<PropsWithChildren> = ({ children }) => {
  return <Paragraph10 colorVariant={'20'}>{children}</Paragraph10>;
};

export { ApiReferenceTypeText };
